{
  "metrics": {
    "Wydajność": {
      "weight": 2,
      "max": 200,
      "direction": "up",
      "format": {
        "decimals": 1,
        "suffix": " mandatów na strażnika miesięcznie",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 6.2,
      "raw_max": 14.3
    },
    "Pobłażliwość": {
      "weight": 1,
      "max": 100,
      "direction": "down",
      "format": {
        "decimals": 0,
        "suffix": "% pouczeń",
        "prefix": ""
      },
      "raw_min": 6.0,
      "raw_avg": 40.0,
      "raw_max": 95.0
    },
    "Blokady": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 1,
        "suffix": " blokad na strażnika miesięcznie",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 2.6,
      "raw_max": 6.8
    },
    "Holowania": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": " holowań na 100k mieszkańców",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 171.0,
      "raw_max": 798.0
    },
    "Holowanie z przejść": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 1,
        "suffix": " holowań na 100k mieszkańców",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 3.3,
      "raw_max": 18.1
    },
    "Holowanie wraków": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": " wraków na 100k mieszkańców",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 35.0,
      "raw_max": 88.0
    },
    "Współpraca": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": "% zamkniętych spraw w UD",
        "prefix": ""
      },
      "raw_min": 0.0,
      "raw_avg": 17.0,
      "raw_max": 55.0
    },
    "Niesprawiedliwość": {
      "weight": 1,
      "max": 100,
      "direction": "down",
      "format": {
        "decimals": 2,
        "suffix": "× (opłaty SPP / mandaty SM za PRD)",
        "prefix": ""
      },
      "raw_min": 0.29,
      "raw_avg": 2.64,
      "raw_max": 8.55
    },
    "Strażnicy": {
      "weight": 1,
      "max": 100,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": " strażników na 100 tys. mieszkańców",
        "prefix": ""
      },
      "raw_min": 10.0,
      "raw_avg": 39.0,
      "raw_max": 68.0
    },
    "Budżet": {
      "weight": 0.5,
      "max": 50,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": " zł na mieszkańca rocznie",
        "prefix": ""
      },
      "raw_min": 3.0,
      "raw_avg": 64.0,
      "raw_max": 140.0
    },
    "Mandaty PRD": {
      "weight": 0.5,
      "max": 50,
      "direction": "down",
      "format": {
        "decimals": 0,
        "suffix": "% mandatów za parkowanie",
        "prefix": ""
      },
      "raw_min": 14.0,
      "raw_avg": 74.0,
      "raw_max": 92.0
    },
    "Koszt mandatu": {
      "weight": 0.5,
      "max": 50,
      "direction": "down",
      "format": {
        "decimals": 0,
        "suffix": " zł",
        "prefix": ""
      },
      "raw_min": 794.0,
      "raw_avg": 2082.0,
      "raw_max": 6994.0
    },
    "Wynagrodzenie": {
      "weight": 0.5,
      "max": 50,
      "direction": "up",
      "format": {
        "decimals": 0,
        "suffix": " zł",
        "prefix": "~"
      },
      "raw_min": 4900.0,
      "raw_avg": 6453.0,
      "raw_max": 9792.0
    }
  },
  "cities": [
    {
      "city": "Białystok",
      "score": 208,
      "Wydajność": {
        "raw": 3.7,
        "normalized": 51
      },
      "Pobłażliwość": {
        "raw": 54.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowania": {
        "raw": 26.0,
        "normalized": 3
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 27.0,
        "normalized": 30
      },
      "Współpraca": {
        "raw": 2.0,
        "normalized": 3
      },
      "Niesprawiedliwość": {
        "raw": 2.44,
        "normalized": 21
      },
      "Strażnicy": {
        "raw": 36.0,
        "normalized": 44
      },
      "Budżet": {
        "raw": 51.0,
        "normalized": 16
      },
      "Mandaty PRD": {
        "raw": 72.0,
        "normalized": 14
      },
      "Koszt mandatu": {
        "raw": 2302.0,
        "normalized": 16
      },
      "Wynagrodzenie": {
        "raw": 5835.0,
        "normalized": 10
      }
    },
    {
      "city": "Bydgoszcz",
      "score": 407,
      "Wydajność": {
        "raw": 5.9,
        "normalized": 82
      },
      "Pobłażliwość": {
        "raw": 29.0,
        "normalized": 53
      },
      "Blokady": {
        "raw": 3.1,
        "normalized": 46
      },
      "Holowania": {
        "raw": 336.0,
        "normalized": 42
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 19.0,
        "normalized": 21
      },
      "Współpraca": {
        "raw": 13.0,
        "normalized": 24
      },
      "Niesprawiedliwość": {
        "raw": 1.18,
        "normalized": 67
      },
      "Strażnicy": {
        "raw": 40.0,
        "normalized": 52
      },
      "Budżet": {
        "raw": 65.0,
        "normalized": 21
      },
      "Mandaty PRD": {
        "raw": 73.0,
        "normalized": 11
      },
      "Koszt mandatu": {
        "raw": 1683.0,
        "normalized": 30
      },
      "Wynagrodzenie": {
        "raw": 4900.0,
        "normalized": 0
      }
    },
    {
      "city": "Gdańsk",
      "score": 545,
      "Wydajność": {
        "raw": 8.1,
        "normalized": 113
      },
      "Pobłażliwość": {
        "raw": 6.0,
        "normalized": 100
      },
      "Blokady": {
        "raw": 3.7,
        "normalized": 54
      },
      "Holowania": {
        "raw": 33.0,
        "normalized": 4
      },
      "Holowanie z przejść": {
        "raw": 1.0,
        "normalized": 6
      },
      "Holowanie wraków": {
        "raw": 34.0,
        "normalized": 39
      },
      "Współpraca": {
        "raw": 46.0,
        "normalized": 84
      },
      "Niesprawiedliwość": {
        "raw": 3.36,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 51.0,
        "normalized": 71
      },
      "Budżet": {
        "raw": 92.0,
        "normalized": 31
      },
      "Mandaty PRD": {
        "raw": 79.0,
        "normalized": 2
      },
      "Koszt mandatu": {
        "raw": 1454.0,
        "normalized": 35
      },
      "Wynagrodzenie": {
        "raw": 5467.0,
        "normalized": 6
      }
    },
    {
      "city": "Gorzów",
      "score": 519,
      "Wydajność": {
        "raw": 7.3,
        "normalized": 102
      },
      "Pobłażliwość": {
        "raw": 67.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowania": {
        "raw": 207.0,
        "normalized": 26
      },
      "Holowanie z przejść": {
        "raw": 15.0,
        "normalized": 83
      },
      "Holowanie wraków": {
        "raw": 53.0,
        "normalized": 60
      },
      "Współpraca": {
        "raw": 29.0,
        "normalized": 53
      },
      "Niesprawiedliwość": {
        "raw": 0.29,
        "normalized": 100
      },
      "Strażnicy": {
        "raw": 14.0,
        "normalized": 7
      },
      "Budżet": {
        "raw": 19.0,
        "normalized": 3
      },
      "Mandaty PRD": {
        "raw": 72.0,
        "normalized": 14
      },
      "Koszt mandatu": {
        "raw": 1077.0,
        "normalized": 44
      },
      "Wynagrodzenie": {
        "raw": 7475.0,
        "normalized": 26
      }
    },
    {
      "city": "Katowice",
      "score": 464,
      "Wydajność": {
        "raw": 7.9,
        "normalized": 111
      },
      "Pobłażliwość": {
        "raw": 17.0,
        "normalized": 83
      },
      "Blokady": {
        "raw": 3.1,
        "normalized": 46
      },
      "Holowania": {
        "raw": 9.0,
        "normalized": 1
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 29.0,
        "normalized": 33
      },
      "Współpraca": {
        "raw": 2.0,
        "normalized": 3
      },
      "Niesprawiedliwość": {
        "raw": 1.32,
        "normalized": 62
      },
      "Strażnicy": {
        "raw": 44.0,
        "normalized": 58
      },
      "Budżet": {
        "raw": 67.0,
        "normalized": 22
      },
      "Mandaty PRD": {
        "raw": 81.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 1296.0,
        "normalized": 39
      },
      "Wynagrodzenie": {
        "raw": 5578.0,
        "normalized": 7
      }
    },
    {
      "city": "Kielce",
      "score": 431,
      "Wydajność": {
        "raw": 5.3,
        "normalized": 74
      },
      "Pobłażliwość": {
        "raw": 36.0,
        "normalized": 35
      },
      "Blokady": {
        "raw": 6.5,
        "normalized": 95
      },
      "Holowania": {
        "raw": 10.0,
        "normalized": 1
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 10.0,
        "normalized": 12
      },
      "Współpraca": {
        "raw": 46.0,
        "normalized": 84
      },
      "Niesprawiedliwość": {
        "raw": 3.6,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 38.0,
        "normalized": 48
      },
      "Budżet": {
        "raw": 47.0,
        "normalized": 14
      },
      "Mandaty PRD": {
        "raw": 67.0,
        "normalized": 21
      },
      "Koszt mandatu": {
        "raw": 1307.0,
        "normalized": 38
      },
      "Wynagrodzenie": {
        "raw": 5640.0,
        "normalized": 8
      }
    },
    {
      "city": "Kraków",
      "score": 561,
      "Wydajność": {
        "raw": 8.3,
        "normalized": 117
      },
      "Pobłażliwość": {
        "raw": 51.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 3.6,
        "normalized": 53
      },
      "Holowania": {
        "raw": 108.0,
        "normalized": 14
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 67.0,
        "normalized": 76
      },
      "Współpraca": {
        "raw": 26.0,
        "normalized": 47
      },
      "Niesprawiedliwość": {
        "raw": 2.67,
        "normalized": 12
      },
      "Strażnicy": {
        "raw": 53.0,
        "normalized": 73
      },
      "Budżet": {
        "raw": 133.0,
        "normalized": 47
      },
      "Mandaty PRD": {
        "raw": 57.0,
        "normalized": 38
      },
      "Koszt mandatu": {
        "raw": 1450.0,
        "normalized": 35
      },
      "Wynagrodzenie": {
        "raw": 9792.0,
        "normalized": 50
      }
    },
    {
      "city": "Lublin",
      "score": 511,
      "Wydajność": {
        "raw": 9.9,
        "normalized": 139
      },
      "Pobłażliwość": {
        "raw": 13.0,
        "normalized": 94
      },
      "Blokady": {
        "raw": 6.3,
        "normalized": 93
      },
      "Holowania": {
        "raw": 353.0,
        "normalized": 44
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 1.0,
        "normalized": 1
      },
      "Współpraca": {
        "raw": 13.0,
        "normalized": 24
      },
      "Niesprawiedliwość": {
        "raw": null,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 33.0,
        "normalized": 39
      },
      "Budżet": {
        "raw": 48.0,
        "normalized": 15
      },
      "Mandaty PRD": {
        "raw": 79.0,
        "normalized": 2
      },
      "Koszt mandatu": {
        "raw": 962.0,
        "normalized": 46
      },
      "Wynagrodzenie": {
        "raw": 6288.0,
        "normalized": 14
      }
    },
    {
      "city": "Olsztyn",
      "score": 481,
      "Wydajność": {
        "raw": 6.0,
        "normalized": 84
      },
      "Pobłażliwość": {
        "raw": 55.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 6.8,
        "normalized": 100
      },
      "Holowania": {
        "raw": 133.0,
        "normalized": 17
      },
      "Holowanie z przejść": {
        "raw": 7.0,
        "normalized": 39
      },
      "Holowanie wraków": {
        "raw": 36.0,
        "normalized": 41
      },
      "Współpraca": {
        "raw": 16.0,
        "normalized": 28
      },
      "Niesprawiedliwość": {
        "raw": 0.32,
        "normalized": 99
      },
      "Strażnicy": {
        "raw": 26.0,
        "normalized": 27
      },
      "Budżet": {
        "raw": 40.0,
        "normalized": 12
      },
      "Mandaty PRD": {
        "raw": 77.0,
        "normalized": 4
      },
      "Koszt mandatu": {
        "raw": 1656.0,
        "normalized": 30
      },
      "Wynagrodzenie": {
        "raw": 4900.0,
        "normalized": 0
      }
    },
    {
      "city": "Opole",
      "score": 414,
      "Wydajność": {
        "raw": 3.6,
        "normalized": 50
      },
      "Pobłażliwość": {
        "raw": 62.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 1.7,
        "normalized": 25
      },
      "Holowania": {
        "raw": 101.0,
        "normalized": 13
      },
      "Holowanie z przejść": {
        "raw": 18.1,
        "normalized": 100
      },
      "Holowanie wraków": {
        "raw": 20.0,
        "normalized": 23
      },
      "Współpraca": {
        "raw": 55.0,
        "normalized": 100
      },
      "Niesprawiedliwość": {
        "raw": 8.55,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 35.0,
        "normalized": 42
      },
      "Budżet": {
        "raw": 73.0,
        "normalized": 24
      },
      "Mandaty PRD": {
        "raw": 73.0,
        "normalized": 12
      },
      "Koszt mandatu": {
        "raw": 3558.0,
        "normalized": 0
      },
      "Wynagrodzenie": {
        "raw": 7320.0,
        "normalized": 25
      }
    },
    {
      "city": "Poznań",
      "score": 649,
      "Wydajność": {
        "raw": 14.3,
        "normalized": 200
      },
      "Pobłażliwość": {
        "raw": 8.0,
        "normalized": 100
      },
      "Blokady": {
        "raw": 5.6,
        "normalized": 82
      },
      "Holowania": {
        "raw": 221.0,
        "normalized": 28
      },
      "Holowanie z przejść": {
        "raw": 7.7,
        "normalized": 43
      },
      "Holowanie wraków": {
        "raw": 35.0,
        "normalized": 40
      },
      "Współpraca": {
        "raw": 5.0,
        "normalized": 9
      },
      "Niesprawiedliwość": {
        "raw": 3.5,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 45.0,
        "normalized": 61
      },
      "Budżet": {
        "raw": 75.0,
        "normalized": 25
      },
      "Mandaty PRD": {
        "raw": 82.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 794.0,
        "normalized": 50
      },
      "Wynagrodzenie": {
        "raw": 6018.0,
        "normalized": 11
      }
    },
    {
      "city": "Rzeszów",
      "score": 177,
      "Wydajność": {
        "raw": 4.1,
        "normalized": 57
      },
      "Pobłażliwość": {
        "raw": 50.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowania": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 0.0,
        "normalized": 0
      },
      "Współpraca": {
        "raw": 12.0,
        "normalized": 21
      },
      "Niesprawiedliwość": {
        "raw": 2.08,
        "normalized": 34
      },
      "Strażnicy": {
        "raw": 28.0,
        "normalized": 32
      },
      "Budżet": {
        "raw": 34.0,
        "normalized": 9
      },
      "Mandaty PRD": {
        "raw": 81.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 1968.0,
        "normalized": 23
      },
      "Wynagrodzenie": {
        "raw": 4900.0,
        "normalized": 0
      }
    },
    {
      "city": "Szczecin",
      "score": 461,
      "Wydajność": {
        "raw": 7.8,
        "normalized": 109
      },
      "Pobłażliwość": {
        "raw": 27.0,
        "normalized": 59
      },
      "Blokady": {
        "raw": 2.5,
        "normalized": 36
      },
      "Holowania": {
        "raw": 233.0,
        "normalized": 29
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 66.0,
        "normalized": 74
      },
      "Współpraca": {
        "raw": 6.0,
        "normalized": 11
      },
      "Niesprawiedliwość": {
        "raw": 1.43,
        "normalized": 58
      },
      "Strażnicy": {
        "raw": 30.0,
        "normalized": 34
      },
      "Budżet": {
        "raw": 47.0,
        "normalized": 14
      },
      "Mandaty PRD": {
        "raw": 92.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 1546.0,
        "normalized": 33
      },
      "Wynagrodzenie": {
        "raw": 5175.0,
        "normalized": 3
      }
    },
    {
      "city": "Toruń",
      "score": 321,
      "Wydajność": {
        "raw": 4.7,
        "normalized": 65
      },
      "Pobłażliwość": {
        "raw": 56.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 2.2,
        "normalized": 32
      },
      "Holowania": {
        "raw": 7.0,
        "normalized": 1
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 12.0,
        "normalized": 13
      },
      "Współpraca": {
        "raw": 0.0,
        "normalized": 0
      },
      "Niesprawiedliwość": {
        "raw": 1.14,
        "normalized": 69
      },
      "Strażnicy": {
        "raw": 53.0,
        "normalized": 74
      },
      "Budżet": {
        "raw": 74.0,
        "normalized": 25
      },
      "Mandaty PRD": {
        "raw": 85.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 2079.0,
        "normalized": 21
      },
      "Wynagrodzenie": {
        "raw": 7012.0,
        "normalized": 22
      }
    },
    {
      "city": "Warszawa",
      "score": 533,
      "Wydajność": {
        "raw": 5.3,
        "normalized": 75
      },
      "Pobłażliwość": {
        "raw": 29.0,
        "normalized": 53
      },
      "Blokady": {
        "raw": 0.6,
        "normalized": 8
      },
      "Holowania": {
        "raw": 798.0,
        "normalized": 100
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 88.0,
        "normalized": 100
      },
      "Współpraca": {
        "raw": 3.0,
        "normalized": 6
      },
      "Niesprawiedliwość": {
        "raw": 4.26,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 68.0,
        "normalized": 100
      },
      "Budżet": {
        "raw": 140.0,
        "normalized": 50
      },
      "Mandaty PRD": {
        "raw": 81.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 2578.0,
        "normalized": 10
      },
      "Wynagrodzenie": {
        "raw": 8020.0,
        "normalized": 32
      }
    },
    {
      "city": "Wrocław",
      "score": 431,
      "Wydajność": {
        "raw": 4.9,
        "normalized": 69
      },
      "Pobłażliwość": {
        "raw": 30.0,
        "normalized": 49
      },
      "Blokady": {
        "raw": 0.2,
        "normalized": 2
      },
      "Holowania": {
        "raw": 433.0,
        "normalized": 54
      },
      "Holowanie z przejść": {
        "raw": 10.4,
        "normalized": 58
      },
      "Holowanie wraków": {
        "raw": 54.0,
        "normalized": 62
      },
      "Współpraca": {
        "raw": 1.0,
        "normalized": 2
      },
      "Niesprawiedliwość": {
        "raw": 3.21,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 46.0,
        "normalized": 62
      },
      "Budżet": {
        "raw": 65.0,
        "normalized": 21
      },
      "Mandaty PRD": {
        "raw": 90.0,
        "normalized": 0
      },
      "Koszt mandatu": {
        "raw": 2150.0,
        "normalized": 19
      },
      "Wynagrodzenie": {
        "raw": 8163.0,
        "normalized": 33
      }
    },
    {
      "city": "Zielona Góra",
      "score": 138,
      "Wydajność": {
        "raw": 0.0,
        "normalized": 0
      },
      "Pobłażliwość": {
        "raw": 95.0,
        "normalized": 0
      },
      "Blokady": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowania": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 39.0,
        "normalized": 44
      },
      "Współpraca": {
        "raw": 11.0,
        "normalized": 19
      },
      "Niesprawiedliwość": {
        "raw": null,
        "normalized": 0
      },
      "Strażnicy": {
        "raw": 10.0,
        "normalized": 0
      },
      "Budżet": {
        "raw": 3.0,
        "normalized": 0
      },
      "Mandaty PRD": {
        "raw": 14.0,
        "normalized": 50
      },
      "Koszt mandatu": {
        "raw": 6994.0,
        "normalized": 0
      },
      "Wynagrodzenie": {
        "raw": 7396.0,
        "normalized": 26
      }
    },
    {
      "city": "Łódź",
      "score": 348,
      "Wydajność": {
        "raw": 3.8,
        "normalized": 53
      },
      "Pobłażliwość": {
        "raw": 30.0,
        "normalized": 51
      },
      "Blokady": {
        "raw": 1.6,
        "normalized": 23
      },
      "Holowania": {
        "raw": 80.0,
        "normalized": 10
      },
      "Holowanie z przejść": {
        "raw": 0.0,
        "normalized": 0
      },
      "Holowanie wraków": {
        "raw": 42.0,
        "normalized": 48
      },
      "Współpraca": {
        "raw": 13.0,
        "normalized": 24
      },
      "Niesprawiedliwość": {
        "raw": 2.83,
        "normalized": 6
      },
      "Strażnicy": {
        "raw": 50.0,
        "normalized": 68
      },
      "Budżet": {
        "raw": 83.0,
        "normalized": 28
      },
      "Mandaty PRD": {
        "raw": 72.0,
        "normalized": 14
      },
      "Koszt mandatu": {
        "raw": 2619.0,
        "normalized": 9
      },
      "Wynagrodzenie": {
        "raw": 6274.0,
        "normalized": 14
      }
    }
  ]
}